import { TFunction } from "react-i18next";
import { NavigateFunction } from "react-router-dom";
import { constants, ls_vars } from "../Constants";
import toast from "react-hot-toast";
import { getLocalStorage, setLocalStorage } from "../../Network/ApiService";
import moment from "moment";
import "moment-timezone";
import { legacyTimeList } from "../../StaticData/SiteManagement/Availability";
import { extensionLogo } from "StaticData/BookingList/fileExtension";
import ExcelJS from 'exceljs';

interface ColInfo {
  wch?: number;
  wpx?: number;
  width?: number;
  [key: string]: any;
}

interface DropdownOption {
  columnName: string;
  options: string[];
}

interface TemplateConfig {
  headers: string[];
  dropdownColumns: DropdownOption[];
}

const projectTimeZone = getLocalStorage(ls_vars.PROJECT_TIMEZONE);

export const isRequired = (value: string) => {
  if (value === "" || value === undefined || value === null) {
    return true;
  }
  return false;
};

export function validateEmail(email: string) {
  const emailRegx = new RegExp(
    /^\w+(?:[.-]\w+)*@\w+(?:[.-]\w+)*(?:\.\w{2,16})+$/
  );
  return emailRegx.test(email) !== false;
}

export function validatePhoneNumber(phonenumber: string) {
  const phonenumberRegx = new RegExp(
    /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/
  );
  return phonenumberRegx.test(phonenumber) !== false;
}
export function isPassword(value: string) {
  const str = value;
  if (
    str.match(/[a-z]/g) &&
    str.match(/[A-Z]/g) &&
    str.match(/[0-9]/g) &&
    str.match(/[^a-zA-Z\d]/g) &&
    str.length >= 8 &&
    str.length <= 16
  ) {
    return true;
  }
  return false;
}
export function isNum(value: any) {
  let number = value;
  if (isNaN(number)) {
    number = number.slice(0, -1);
    return number;
  }
  return number;
}

export const removeExtraSpaceCKEditor = (str: string) => {
  let token = "<p>&nbsp;</p>";

  while (str?.startsWith(token)) {
    str = str?.replace(token, "");
  }
  while (str?.endsWith(token)) {
    str = str?.replace(token, "");
  }
  return str;
};
export function isCheckUppercase(value: string) {
  const str = value;
  if (str.match(/[A-Z]/g)) {
    return true;
  }
  return false;
}
export function isCheckLowercase(value: string) {
  const str = value;
  if (str.match(/[a-z]/g)) {
    return true;
  }
  return false;
}
export function isCheckNumber(value: string) {
  const str = value;
  if (/\d/.test(str)) {
    return true;
  }
  return false;
}
export function isCheckSpecialChar(value: string) {
  const str = value;
  if (str.match(/[^a-zA-Z\d]/g)) {
    return true;
  }
  return false;
}
export function isCheckMinLength(value: string) {
  const str = value;
  if (str.length >= 8) {
    return true;
  }
  return false;
}
export function isCheckMaxLength(value: string) {
  const str = value;
  if (str.length <= 16) {
    return true;
  }
  return false;
}
export function formatTime24to12Hour(timeString: string) {
  // Check if input already has AM/PM in any case
  const ampmMatch = timeString.match(/(am|pm)$/i);
  if (ampmMatch) {
    const normalized = timeString.replace(/(am|pm)$/i, ampmMatch[0].toUpperCase());
    return normalized;
  }

  // Handle 24-hour format
  const [hourString, minute] = timeString.split(":");
  const hour = +hourString % 24;
  const converted =
    (hour % 12 || 12) + ":" + minute + " " + (hour < 12 ? "AM" : "PM");

  return converted;
}
export const getLastDayOfMonth = (y: number, m: number) => {
  return new Date(y, m, 0).getDate();
};
export const getLastDayOfYear = (year: number) => {
  return new Date(year, 11, 31, 5, 30);
};

export const convertCamelCase = (inputString: string) => {
  if (inputString) {
    return (
      inputString.slice(0, 1).toUpperCase() +
      inputString.slice(1).toLocaleLowerCase()
    );
  } else {
    return "";
  }
};
export const checkValidZip = (value: string) => {
  return value.replace(/[^a-zA-Z0-9 ]/g, "");
};
export const isCheckSpecialCharInString = (value: string) => {
  const regex = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return regex.test(value);
};
export const formateDateFromDateObject = (date: Date) => {
  return date.toDateString();
};
export const backGroundScroll = (isModalOpen: boolean) => {
  if (isModalOpen) {
    document.body.className = "modal-open-scroll";
  } else {
    document.body.classList.remove("modal-open-scroll");
  }
};

export const formatDate = (dateStr: string | Date): string => {
  if (!dateStr) return "";
  if (dateStr instanceof Date) {
    const month = String(dateStr.getMonth() + 1).padStart(2, "0");
    const day = String(dateStr.getDate()).padStart(2, "0");
    return `${dateStr.getFullYear()}-${month}-${day}`;
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
  if (dateStr.includes("T")) return dateStr.split("T")[0];
  const d = new Date(dateStr);
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${month}-${day}`;
};

export const getTimeDifference = (startTime: string, endTime: string) => {
  if (startTime !== undefined && endTime !== undefined) {
    // Parse time strings properly handling both 12-hour and 24-hour formats
    const parseTime = (timeStr: string) => {
      const cleanTime = timeStr.trim();
      const isAM = cleanTime.toLowerCase().includes('am');
      const isPM = cleanTime.toLowerCase().includes('pm');
      
      const timePart = cleanTime.replace(/\s*(am|pm)\s*/gi, '');
      const [hourStr, minStr] = timePart.split(':');
      
      let hour = parseInt(hourStr);
      const minute = parseInt(minStr || '0');
      
      // Convert to 24-hour format if needed
      if (isPM && hour !== 12) hour += 12;
      if (isAM && hour === 12) hour = 0;
      
      return { hour, minute };
    };
    
    const start = parseTime(startTime);
    const end = parseTime(endTime);
    
    // Calculate total minutes
    const startMinutes = start.hour * 60 + start.minute;
    const endMinutes = end.hour * 60 + end.minute;
    
    let diffMinutes = endMinutes - startMinutes;
    
    // Handle next day scenarios
    if (diffMinutes < 0) {
      diffMinutes += 24 * 60; // Add 24 hours worth of minutes
    }
    
    // Convert to decimal hours
    const decimalHours = diffMinutes / 60;
    
    // Format as decimal (0.5hrs, 1hrs, 1.5hrs, 1.75hrs)
    if (decimalHours === 0) {
      return "0hrs";
    } else if (decimalHours % 1 === 0) {
      return `${decimalHours}hrs`;
    } else {
      return `${decimalHours}hrs`;
    }
  }
  return "";
};

export function dataURItoBlob(dataURI: string) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(",")[0].indexOf("base64") >= 0)
    byteString = atob(dataURI.split(",")[1]);
  else byteString = unescape(dataURI.split(",")[1]);

  // separate out the mime component
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia], { type: mimeString });
}

export const blobToFile = (blobUrl: Blob) => {
  const myFile = new File([blobUrl], "image.jpeg", {
    type: blobUrl.type,
  });
  return myFile;
};

export const getFileInfoFromUrl = (url: string) => {
  const fileName = url?.split("?")[0].split("/").pop() || "";
  const fileExtension = fileName && fileName.split(".").pop();
  const fileIcon = fileExtension && extensionLogo?.[fileExtension];
  return {
    fileName,
    fileExtension,
    fileIcon,
  };
};

export const getFileName = (url: string) => {
  return url?.split("?")[0].split("/").slice(-1);
};

export const getFileExtension = (fileName: string) => {
  if (fileName) {
    return fileName[0].split(".").slice(-1)[0];
  } else {
    return fileName;
  }
};

function padTo2Digits(num: number) {
  return num.toString().padStart(2, "0");
}

export const miliSecondsToTime = (miliSec: number, timeFormat: string) => {
  let seconds = Math.floor(miliSec / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);

  seconds = seconds % 60;
  minutes = minutes % 60;

  hours = hours % 24;

  return timeFormat === constants.HOUR_12
    ? formatTime24to12Hour(
      padTo2Digits(hours) +
      ":" +
      padTo2Digits(minutes) +
      ":" +
      padTo2Digits(seconds)
    )
    : (
      padTo2Digits(hours) +
      ":" +
      padTo2Digits(minutes) +
      ":" +
      padTo2Digits(seconds)
    ).substring(0, 5);
};

export const viewImageFromURL = (url: string) => {
  fetch(url).then((response) => {
    response.blob().then((blob) => {
      let url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    });
  });
};

export const downloadImageFromURL = (url: string) => {
  fetch(url).then((response) => {
    response.blob().then((blob) => {
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.download = url?.split("?")[0].split("/").slice(-1)[0];
      a.click();
      a.remove();
    });
  });
};

export const formateDateAsPerUserPreference = (
  dateString: string,
  dateFormat: number = 1
) => {
  return toFormattedDateString(dateString, dateFormat);
};

export const getFormattedDateTime = (modifiedAt: string) => {
  const PREFERENCE = getLocalStorage(ls_vars.USER_PREFERENCES);
  const projectTimeZone = getLocalStorage(ls_vars.PROJECT_TIMEZONE);
  const timeFormat = PREFERENCE?.timeFormat?.format;
  const dateFormat = PREFERENCE?.dateFormat?.id;

  if (modifiedAt) {
    // Parse the UTC date string
    const date = new Date(modifiedAt);

    // Convert the date to the target time zone
    const options: Intl.DateTimeFormatOptions = {
      timeZone: projectTimeZone,
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: timeFormat === "24 hour",
    };
    const formatter = new Intl.DateTimeFormat("en-US", options);
    const parts = formatter.formatToParts(date);

    // Extract and format date and time parts
    let formattedDate = "";
    let formattedTime = "";

    parts.forEach((part) => {
      if (
        part.type === "weekday" ||
        part.type === "month" ||
        part.type === "day" ||
        part.type === "year"
      ) {
        formattedDate += part.value + " ";
      } else if (
        part.type === "hour" ||
        part.type === "minute" ||
        part.type === "second" ||
        part.type === "dayPeriod"
      ) {
        formattedTime += part.value + (part.type === "dayPeriod" ? " " : ":");
      }
    });

    // Remove trailing colon if present
    formattedTime = formattedTime.replace(/:$/, "").trim();

    return {
      date: formateDateAsPerUserPreference(formattedDate.trim(), dateFormat),
      time: formateTimeAsPerUserPreference(formattedTime, timeFormat),
    };
  }
  return null;
};

export const formateTimeAsPerUserPreference = (
  timeString: string,
  timeFormat: string
) => {
  return timeString && timeFormat === constants.HOUR_12
    ? formatTime24to12Hour(timeString)
    : timeString?.substring(0, 5);
};

// Ensures that the opened link in new Tab
export const openLinkToNewTab = (htmlContent: string) => {
  let div = document.createElement("div");
  div.innerHTML = htmlContent;
  div.querySelectorAll("a").forEach((item) => {
    item.setAttribute("target", "_blank");
    item.setAttribute("rel", "noopener noreferrer");
  });

  return div.innerHTML;
};

export const removeDuplicates = (arr: any[]) => {
  let outputArray: any[] = [];
  let newArr: any[] = [];
  arr.filter((item: any, index: number) => {
    if (!outputArray.includes(item?.slotStart?.time)) {
      outputArray.push(item?.slotStart?.time);
      newArr.push(item);
    }
  });
  return newArr;
};

export const getReadableAddress = (address: string) => {
  return address && String(address.replaceAll(",", "").split(" ").splice(1));
};

export const capitalizeFirstLetter = (string: string) => {
  return string.slice(0, 1).toUpperCase() + string.slice(1);
};

export const camelCaseToSnakeCase = (
  name: string,
  replaceWith: string = "_"
) => {
  name.replace(/[A-Z]/g, (c) => {
    return replaceWith + c;
  });

  return name.replace(/[A-Z]/g, (c) => {
    return replaceWith + c;
  });
};

export const toSnakeCase = (value: string): string => {
  if (!value || value.trim() === "") return "";
  return value
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "_");
};

export const buildDateObject: (date: string, time: string) => Date = (
  date: string,
  time: string
) => {
  const [hour, min, sec] = time.split(":").map((item) => parseInt(item));
  const [year, month, day] = date.split("-").map((item) => parseInt(item));
  
  // Create date using local Date constructor to avoid timezone shifts
  // The calendar will display these times as-is without conversion
  return new Date(year, month - 1, day, hour, min, sec || 0);
};
export const get30minSlots: (start: string, end: string) => string[] = (
  start: string,
  end: string
) => {
  let slots = [];
  let current = new Date(`1970-01-01T${start}:00`);
  let endDateTime = new Date(`1970-01-01T${end}:00`);
  while (current <= endDateTime) {
    slots.push(
      current.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    );
    current = new Date(current.getTime() + 30 * 60000);
  }
  return slots;
};

export const handleError = (
  data: any,
  t: TFunction<"translation", undefined>
) => {
  Object.keys(data).map((item) => {
    toast.error(t(`Translation.${data[item]}`));
  });
};

export const getOrdinalSuffix: (day: number) => string = (day: number) => {
  const suffixes = ["th", "st", "nd", "rd"];
  const v = day % 100;
  return day + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};

export const createParamsString = (paramsData: any[]) => {
  let paramsString = "";
 
  paramsData.forEach((item, index) => {
    Object.entries(item).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        
        let formattedValue = value;
 
        if (Array.isArray(value)) {
          formattedValue = `[${value.join(",")}]`;
        }

        paramsString += `${key}=${formattedValue}`;
 
        paramsString += "&";
      }
    });
  });
  
  return paramsString.slice(0, -1);
};


const jaWeekDays = {
  Sun: "日",
  Mon: "月",
  Tue: "火",
  Wed: "水",
  Thu: "木",
  Fri: "金",
  Sat: "土",
};

const esWeekDays = {
  Sun: "dom",
  Mon: "lun",
  Tue: "mar",
  Wed: "mié",
  Thu: "jue",
  Fri: "vie",
  Sat: "sáb",
};

export const toFormattedDateString = (date?: string, dateFormat?: number) => {
  if (date && new Date(date).toDateString() !== "Invalid Date") {
    const locale = getLocalStorage("i18nextLng");
    if (locale === "ja") {
      const weekDay = moment(date).format("ddd");
      return (
        moment(date).format("YYYY/MM/DD") +
        `(${jaWeekDays[weekDay as keyof typeof jaWeekDays]})`
      );
    } else if (locale === "es") {
      const weekDay = moment(date).format("ddd");
      return (
        moment(date).format("YYYY/MM/DD") +
        `(${esWeekDays[weekDay as keyof typeof esWeekDays]})`
      );
    } else {
      let formatToCheck =
        dateFormat ||
        getLocalStorage(ls_vars.USER_PREFERENCES)?.dateFormat?.id ||
        1;
      switch (formatToCheck) {
        case 1:
          return moment(date).format("ddd, Do MMMM YYYY");
        case 2:
          return moment(date).format("ddd, MMMM Do YYYY");
        case 3:
          return moment(date).format("YYYY, MMMM Do ddd");
        default:
          "";
      }
    }
  }
  return "";
};

export const getWeekday = (dateString: string) => {
  let [year, month, day] = dateString?.split("-").map((item) => parseInt(item));
  // Convert month to 0-based index (0=January, 11=December)
  month -= 1;

  // Adjust year and month if January or February
  if (month < 2) {
    year -= 1;
    month += 12;
  }

  // Calculate weekday (0=Sunday, 1=Monday, ..., 6=Saturday)
  const q = day;
  const m = month + 1;
  const k = year % 100;
  const j = Math.floor(year / 100);
  const h =
    (q +
      Math.floor((12 * (m + 1)) / 5) +
      k +
      Math.floor(k / 4) +
      Math.floor(j / 4) +
      5 * j) %
    7;

  return h;
};

export const sort = (array: any[], sort_by: string = "order") => {
  for (let index = 0; index < array.length; index++) {
    for (let loopIndex = 0; loopIndex < array.length - index - 1; loopIndex++) {
      if (array[loopIndex][sort_by] > array[loopIndex + 1][sort_by]) {
        const temp = array[loopIndex];
        array[loopIndex] = array[loopIndex + 1];
        array[loopIndex + 1] = temp;
      }
    }
  }
  return array;
};

export const snakeCaseToCamelCase: (name: string) => any = (name: string) => {
  return name.replace(/_([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
};

export const getTimeId: (date: string) => number = (date: string) => {
  const timeString = moment(date).toDate().toLocaleTimeString("en-US", {
    timeStyle: "short",
    timeZone: "UTC",
  });
  const timeIdIndex = legacyTimeList.findIndex(
    (item) => item.label === timeString
  );
  return legacyTimeList[timeIdIndex].value;
};

export const getTimeLabelFromId: (date: number) => string = (date: number) => {
  const timeIdIndex = legacyTimeList.findIndex((item) => item.value === date);
  return legacyTimeList[timeIdIndex].label;
};

export const formatTimeForSiteAvailability = (
  date: string,
  legacyTimeId: number
) => {
  return (
    moment(date).format("YYYY-MM-DD") +
    " " +
    moment(getTimeLabelFromId(legacyTimeId), "h:mm A").format("HH:mm:ss")
  );
};

export function calculateTimeDifference(timeObj: {
  startTimeStr: string;
  endTimeStr: string;
}) {
  // Parse the time strings into Date objects
  const startTime = new Date(`1970-01-01T${timeObj.startTimeStr}Z`);
  const endTime = new Date(`1970-01-01T${timeObj.endTimeStr}Z`);

  // Calculate the difference in milliseconds
  const differenceInMs = +endTime - +startTime;

  // Convert the difference back to hours, minutes, and seconds
  const totalSeconds = Math.floor(differenceInMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Format the result as HH:mm:ss
  const timeDifferenceStr = `${String(hours).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  return timeDifferenceStr;
}

export const getSlotLabelBaseOnPreferences = (timeString: string) => {
  // expecting '14:00:00' format became '14:00' or '2:00 PM'
  const timeFormat = getLocalStorage(ls_vars.USER_PREFERENCES)?.timeFormat
    ?.format;
  return timeFormat === constants.HOUR_12
    ? formatTime24to12Hour(timeString)
    : timeString?.substring(0, 5);
};

export const getSlotWeekdayFormDate = (dateString: string) => {
  // expecting '2024-07-24' format became "WEDNESDAY"
  return moment(dateString).format("dddd").toLowerCase();
};

export const generateExcelTemplate = async (config: TemplateConfig): Promise<Blob> => {
  const workbook = new ExcelJS.Workbook();

  // Create worksheets
  const mainSheet = workbook.addWorksheet('Template');
  const optionsSheet = workbook.addWorksheet('Options');

  // Add headers to main sheet
  mainSheet.addRow(config.headers);

  // Style headers
  const headerRow = mainSheet.getRow(1);
  headerRow.font = { bold: true };

  // Add dropdown options to options sheet
  config.dropdownColumns.forEach((dropdown, index) => {
    const colIndex = config.headers.indexOf(dropdown.columnName);
    if (colIndex !== -1) {
      // Add dropdown options in the Options sheet (1st row is the header)
      optionsSheet.getColumn(index + 1).values = [dropdown.columnName, ...dropdown.options];

      // Pre-fill empty cells in the main sheet to apply validation
      for (let rowNumber = 2; rowNumber <= 1000; rowNumber++) {
        const cell = mainSheet.getCell(`${String.fromCharCode(65 + colIndex)}${rowNumber}`);
        cell.dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`Options!$${String.fromCharCode(65 + index)}$2:$${String.fromCharCode(65 + index)}$1000`],
          showErrorMessage: true,
          errorStyle: 'error',
          errorTitle: 'Invalid Input',
          error: `Please select a valid ${dropdown.columnName} from the list`
        };
      }
    }
  });

  // Set column widths
  mainSheet.columns = config.headers.map(header => ({
    header,
    width: 20
  }));

  // Generate buffer
  const buffer = await workbook.xlsx.writeBuffer();

  // Return as blob
  return new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
};

// Helper function to flatten an object with nested properties
export const flattenObject = (obj: any, prefix = ''): Record<string, any> => {
  return Object.keys(obj).reduce((acc: Record<string, any>, key: string) => {
    const pre = prefix.length ? `${prefix}.` : '';

    if (
      typeof obj[key] === 'object' &&
      obj[key] !== null &&
      !Array.isArray(obj[key]) &&
      Object.keys(obj[key]).length > 0
    ) {
      // Recursively flatten nested objects
      Object.assign(acc, flattenObject(obj[key], `${pre}${key}`));
    } else {
      // Handle arrays and primitive values
      acc[`${pre}${key}`] = obj[key];
    }

    return acc;
  }, {});
};

// Unit conversion helper
export const convertUnit = {
  // Distance conversions (base: meters)
  distance: {
    mm: { to: { m: (v: number) => v / 1000, cm: (v: number) => v / 10, km: (v: number) => v / 1000000, mi: (v: number) => v / 1609344, ft: (v: number) => v / 304.8, in: (v: number) => v / 25.4 } },
    cm: { to: { m: (v: number) => v / 100, mm: (v: number) => v * 10, km: (v: number) => v / 100000, mi: (v: number) => v / 160934.4, ft: (v: number) => v / 30.48, in: (v: number) => v / 2.54 } },
    m: { to: { mm: (v: number) => v * 1000, cm: (v: number) => v * 100, km: (v: number) => v / 1000, mi: (v: number) => v / 1609.344, ft: (v: number) => v * 3.28084, in: (v: number) => v * 39.3701 } },
    km: { to: { m: (v: number) => v * 1000, mm: (v: number) => v * 1000000, cm: (v: number) => v * 100000, mi: (v: number) => v / 1.609344, ft: (v: number) => v * 3280.84, in: (v: number) => v * 39370.1 } },
    mi: { to: { m: (v: number) => v * 1609.344, mm: (v: number) => v * 1609344, cm: (v: number) => v * 160934.4, km: (v: number) => v * 1.609344, ft: (v: number) => v * 5280, in: (v: number) => v * 63360 } },
    ft: { to: { m: (v: number) => v / 3.28084, mm: (v: number) => v * 304.8, cm: (v: number) => v * 30.48, km: (v: number) => v / 3280.84, mi: (v: number) => v / 5280, in: (v: number) => v * 12 } },
    in: { to: { m: (v: number) => v / 39.3701, mm: (v: number) => v * 25.4, cm: (v: number) => v * 2.54, km: (v: number) => v / 39370.1, mi: (v: number) => v / 63360, ft: (v: number) => v / 12 } }
  },
  // Volume conversions (base: liters)
  volume: {
    ml: { to: { l: (v: number) => v / 1000, gal: (v: number) => v / 3785.41, qt: (v: number) => v / 946.353, pt: (v: number) => v / 473.176, cup: (v: number) => v / 236.588 } },
    l: { to: { ml: (v: number) => v * 1000, gal: (v: number) => v * 0.264172, qt: (v: number) => v * 1.05669, pt: (v: number) => v * 2.11338, cup: (v: number) => v * 4.22675 } },
    gal: { to: { l: (v: number) => v * 3.78541, ml: (v: number) => v * 3785.41, qt: (v: number) => v * 4, pt: (v: number) => v * 8, cup: (v: number) => v * 16 } },
    qt: { to: { l: (v: number) => v / 1.05669, ml: (v: number) => v * 946.353, gal: (v: number) => v / 4, pt: (v: number) => v * 2, cup: (v: number) => v * 4 } }
  },
  // Weight conversions (base: grams)
  weight: {
    mg: { to: { g: (v: number) => v / 1000, kg: (v: number) => v / 1000000, lb: (v: number) => v / 453592, oz: (v: number) => v / 28349.5 } },
    g: { to: { mg: (v: number) => v * 1000, kg: (v: number) => v / 1000, lb: (v: number) => v / 453.592, oz: (v: number) => v / 28.3495 } },
    kg: { to: { g: (v: number) => v * 1000, mg: (v: number) => v * 1000000, lb: (v: number) => v * 2.20462, oz: (v: number) => v * 35.274 } },
    lb: { to: { g: (v: number) => v * 453.592, mg: (v: number) => v * 453592, kg: (v: number) => v / 2.20462, oz: (v: number) => v * 16 } },
    oz: { to: { g: (v: number) => v * 28.3495, mg: (v: number) => v * 28349.5, kg: (v: number) => v / 35.274, lb: (v: number) => v / 16 } }
  },
  // Temperature conversions
  temperature: {
    c: { to: { f: (v: number) => (v * 9/5) + 32, k: (v: number) => v + 273.15 } },
    f: { to: { c: (v: number) => (v - 32) * 5/9, k: (v: number) => ((v - 32) * 5/9) + 273.15 } },
    k: { to: { c: (v: number) => v - 273.15, f: (v: number) => ((v - 273.15) * 9/5) + 32 } }
  }
};

// Normalize string (remove spaces, lowercase)
const normalize = (val: string | undefined) => val?.toLowerCase().trim() ?? "";

// Unit aliases
const distanceUnits = new Set(["km", "kms", "kilometer", "kilometers"]);
const weightUnits = new Set(["kg", "kgs", "kilogram", "kilograms"]);
const volumeUnits = new Set(["l", "ltr", "litre", "liter", "litres", "liters"]);
const temperatureUnits = new Set(["c", "°c", "celsius"]);

export const convertDistance = (distance: any, uom: any) => {
  const distanceValue = parseFloat(distance);
  const unit = normalize(uom?.distance?.name);

  if (distanceUnits.has(unit)) {
    return `${distanceValue} km`;
  }
  return `${convertUnit.distance.km.to.mi(distanceValue).toFixed(2)} mi`;
};

export const extractNumber = (str: string) => {
  if (!str) return 0;
  const cleaned = str.replace(/[^0-9.-]/g, '');  // keep digits, dot, and minus sign
  return parseFloat(cleaned);
}

export const convertWeight = (weight: any, uom: any) => {
  const weightValue = parseFloat(weight);
  const unit = normalize(uom?.weight?.name);

  if (weightUnits.has(unit)) {
    return `${weightValue} kg`;
  }
  return `${convertUnit.weight.kg.to.lb(weightValue).toFixed(2)} lb`;
};

export const convertVolume = (volume: any, uom: any) => {
  const volumeValue = parseFloat(volume);
  const unit = normalize(uom?.volume?.name);

  if (volumeUnits.has(unit)) {
    return `${volumeValue} l`;
  }
  return `${convertUnit.volume.l.to.gal(volumeValue).toFixed(2)} gal`;
};

export const convertTemperature = (temperature: any, uom: any) => {
  const tempValue = parseFloat(temperature);
  const unit = normalize(uom?.temperature?.name);

  if (temperatureUnits.has(unit)) {
    return `${tempValue} °C`;
  }
  return `${convertUnit.temperature.c.to.f(tempValue).toFixed(2)} °F`;
};

export const to12Hour = (time24: string) => {
  if (!time24 || time24 === "") return "";
  const [hour, minute] = time24?.split(":").map(Number);
  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minute?.toString().padStart(2, "0")} ${period}`;
};
